import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenPayloadInterface } from '../interfaces';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard  {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (localStorage.getItem('currentUser')) {
            const tokenPayload: TokenPayloadInterface = JSON.parse(localStorage.getItem('currentToken'));
            const now = Math.round(Date.now()/1000);
            if(tokenPayload && tokenPayload.exp && tokenPayload.exp > now) {
                // console.log('auth guard', tokenPayload.exp, now);
                // logged in so return true
                return true;
            }

        }
        console.log('auth guard failed');

        // not logged in so redirect to login page
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
}
